import { motion } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import Button from './reusable/Button';

const selectOptions = [
	'Web Application',
	'Mobile Application',
	'UI/UX Design',
	'Branding',
];

const HireMeModal = ({ onClose, onRequest }) => {
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			className="fixed inset-0 z-50 flex items-center justify-center p-4"
		>
			{/* Apple Frosted Backdrop */}
			<div
				onClick={onClose}
				className="fixed inset-0 bg-black/40 backdrop-blur-md transition-opacity"
			/>

			{/* Modal Card - Apple HIG Sheet Style */}
			<div className="relative z-10 w-full max-w-lg rounded-3xl bg-white dark:bg-[#1C1C1E] border border-black/[0.08] dark:border-white/[0.12] shadow-2xl overflow-hidden text-left p-6 sm:p-8">
				<div className="flex items-center justify-between pb-4 border-b border-black/[0.06] dark:border-white/[0.08] mb-6">
					<div>
						<h3 className="text-xl sm:text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
							Project Inquiry
						</h3>
						<p className="text-xs sm:text-sm text-slate-500 dark:text-slate-400 mt-1">
							Let's build something extraordinary together.
						</p>
					</div>
					<button
						onClick={onClose}
						type="button"
						className="w-8 h-8 rounded-full flex items-center justify-center bg-black/5 dark:bg-white/10 hover:bg-black/10 dark:hover:bg-white/20 text-slate-500 hover:text-slate-900 dark:hover:text-white transition-all"
						aria-label="Close modal"
					>
						<FiX className="text-lg" />
					</button>
				</div>

				<form
					onSubmit={(e) => {
						e.preventDefault();
						if (onRequest) onRequest();
						onClose();
					}}
					className="space-y-4"
				>
					<div>
						<label className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1">
							Full Name
						</label>
						<input
							className="w-full px-4 py-2.5 rounded-xl border border-black/[0.08] dark:border-white/[0.1] text-sm bg-slate-50 dark:bg-[#2C2C2E] text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-500"
							id="name"
							name="name"
							type="text"
							required
							placeholder="Your Name"
						/>
					</div>

					<div>
						<label className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1">
							Email Address
						</label>
						<input
							className="w-full px-4 py-2.5 rounded-xl border border-black/[0.08] dark:border-white/[0.1] text-sm bg-slate-50 dark:bg-[#2C2C2E] text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-500"
							id="email"
							name="email"
							type="email"
							required
							placeholder="your.email@example.com"
						/>
					</div>

					<div>
						<label className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1">
							Project Type
						</label>
						<select
							className="w-full px-4 py-2.5 rounded-xl border border-black/[0.08] dark:border-white/[0.1] text-sm bg-slate-50 dark:bg-[#2C2C2E] text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500"
							id="subject"
							name="subject"
							required
						>
							{selectOptions.map((option) => (
								<option key={option} value={option}>
									{option}
								</option>
							))}
						</select>
					</div>

					<div>
						<label className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1">
							Project Description
						</label>
						<textarea
							className="w-full px-4 py-2.5 rounded-xl border border-black/[0.08] dark:border-white/[0.1] text-sm bg-slate-50 dark:bg-[#2C2C2E] text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-500"
							id="message"
							name="message"
							rows="4"
							placeholder="Briefly describe what you'd like to achieve..."
							required
						/>
					</div>

					<div className="pt-4 flex items-center justify-end gap-3">
						<button
							onClick={onClose}
							type="button"
							className="px-5 py-2.5 rounded-full text-xs sm:text-sm font-medium text-slate-600 dark:text-slate-400 hover:bg-black/5 dark:hover:bg-white/10 transition-all"
						>
							Cancel
						</button>
						<button
							type="submit"
							className="px-6 py-2.5 rounded-full bg-sky-600 hover:bg-sky-500 active:scale-95 text-white font-semibold text-xs sm:text-sm shadow-sm transition-all"
						>
							Send Request
						</button>
					</div>
				</form>
			</div>
		</motion.div>
	);
};

export default HireMeModal;
